import * as t from "io-ts";
import { fromRefinement } from "io-ts-types";
import type { DateC } from "io-ts-types/date";

const isValidDate = (d: unknown): d is Date => {
  return d instanceof Date && !Number.isNaN(d.getTime());
};
export const validDate: DateC = fromRefinement("Date", isValidDate);
export const ValidDateOrNull = t.union([validDate, t.null]);
